import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "./ui/input-otp";

const PostalCodeInput = ({
  handleChange,
  value,
  id,
  name,
  placeholder,
  required,
  className,
  handleBlur,
  inputClassName,
  disabled = false
}) => {
  return (
    <InputOTP
      maxLength={4}
      onChange={handleChange}
      value={value}
      id={id}
      name={name}
      required={required}
      className={className}
      onBlur={handleBlur}
      disabled={disabled}
    >
      <InputOTPGroup>
        <InputOTPSlot className={inputClassName} index={0} />
        <InputOTPSlot className={inputClassName} index={1} />
        <InputOTPSlot className={inputClassName} index={2} />
        <InputOTPSlot className={inputClassName} index={3} />
      </InputOTPGroup>
    </InputOTP>
  );
};

export default PostalCodeInput;
